import React from 'react';
import { useTranslation } from 'react-i18next';
import { JOB_PORTAL_KEYS, NS } from '../../../../../i18n/constants/keys';
import { Button } from '../../../../../ui';

type ApplySectionProps = {
  onApplyClick: () => void;
};

export const ApplySection = ({ onApplyClick }: ApplySectionProps) => {
  const { t } = useTranslation(NS.jobPortal);

  return (
    <div className='mb-4 rounded-lg bg-emerald-600 p-5 text-center shadow-sm'>
      <h3 className='mb-2 text-lg font-extrabold text-white'>
        { t(JOB_PORTAL_KEYS.apply.readyToApply) }
      </h3>
      <p className='mb-4 text-sm text-emerald-50'>
        { t(JOB_PORTAL_KEYS.apply.joinTeam) }
      </p>
      <Button
          onClick={onApplyClick}
          variant='primary'
          label={t(JOB_PORTAL_KEYS.apply.applyNow)}
          className='w-full rounded-md px-4 py-2 font-semibold'
      />
    </div>
  );
};
